import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

export function SupportCancellationDialog({ open, target, avatarImage, avatarProfileType, onClose, onConfirm }) {
  const artistUsername = target?.supportedUser?.user_username
    ? `@${target.supportedUser.user_username}`
    : target?.supportedUserName ?? 'the artist';

  return (
    <GenericPopup open={open} onBackgroundClick={onClose} opacity className="generic-popup_content profile-support-subscriptions__cancel-popup">
      <div className="generic-popup__header profile-support-subscriptions__cancel-popup-header">
        <Text className="generic-popup__header-text profile-support-subscriptions__cancel-popup-title ">Stop Supporting</Text>
        <XIcon className="generic-popup__close profile-support-subscriptions__cancel-popup-close" onClick={onClose} />
      </div>
      <div className="profile-support-subscriptions__cancel-popup-avatar">
        <UserProfileImage image={avatarImage} typeOfProfile={avatarImage ? avatarProfileType : 'collector'} />
      </div>
      <Text className="profile-support-subscriptions__cancel-popup-message ">
        {`Cancelling your subscription will stop future auto-renewals. You can always come back later - but ${artistUsername} will definitely miss you.`}
      </Text>
      <div className="profile-support-subscriptions__cancel-popup-actions"><ContinueButton onClick={onConfirm}>Cancel Subscription</ContinueButton></div>
    </GenericPopup>
  );
}

export function ChannelRevocationDialog({ open, target, onClose, loading, onConfirm }) {
  const ownerUsername = target?.ownerUsername ? `@${String(target.ownerUsername).replace(/^@/, '')}` : 'the channel creator';

  return (
    <GenericPopup open={open} onBackgroundClick={onClose} opacity className="generic-popup_content profile-channel-subscriptions__revoke-popup">
      <div className="generic-popup__header profile-channel-subscriptions__revoke-popup-header">
        <Text className="generic-popup__header-text profile-channel-subscriptions__revoke-popup-title ">Revoke subscription</Text>
        <XIcon className="generic-popup__close profile-channel-subscriptions__revoke-popup-close" onClick={onClose} />
      </div>
      <Text className="profile-channel-subscriptions__revoke-popup-text ">
        {`Cancelling your subscription will stop future auto-renewals. You can always come back later - but ${ownerUsername} will definitely miss you.`}
      </Text>
      <div className="profile-channel-subscriptions__revoke-popup-actions">
        <ContinueButton loading={loading} onClick={onConfirm}>{loading ? 'Canceling…' : 'Cancel subscription'}</ContinueButton>
      </div>
    </GenericPopup>
  );
}
